<!--  -->

<template>
  <el-dialog :visible.sync="paymentConfirmVisible" :close-on-click-modal="false" :close-on-press-escape="false"
    :show-close="false" title="支付确认" width="440px" class="payment_confirm" center>
    <!-- 订单信息 -->
    <div class="order_info" v-if="advance_sale">
      <img class="goods_pic" :src="advance_sale.goods_list[0].goods_pic" alt="">
      <div class="goods_info">
        <h3 class="goods_name">{{ advance_sale.goods_list[0].goods_name }}</h3>
        <p class="order_amount">订单金额：¥{{ advance_sale.total_price }}</p>

      </div>
      <el-divider></el-divider>
      <div style="overflow: hidden;">
        <p class="earnest_money">已付定金：¥{{ advance_sale.pre_data.dep_price }}</p>
        <div class="money_wrap">
          <p class="balance_money">
            <span class="label">待付尾款：</span>
            ¥{{ advance_sale.pre_data.fin_price }}
          </p>

          <p class="freight">
            <span class="label">运费：</span>
            ¥{{ advance_sale.express_price }}
          </p>
          <p class="account">
            <span class="account_label label">应付款：</span>
            <span class="account_money">¥{{ advance_sale.pay_price }}</span>
          </p>
        </div>
      </div>


      <!-- 支付方式 -->
      <ul class="payment_list">
        <li v-for="(item, index) in ys_pay_type_list" :key="item.pay_type" :class="isActive == index ? 'active' : ''"
          @click="SelectPayment(item, index)">
          <img :src="item.icon" alt="">
          <span>{{ item.name }}</span>
          <div class="active_tip" v-if="isActive == index">
            <i class="iconfont icon-dui"></i>
          </div>
        </li>
      </ul>
    </div>
    <!-- 发票相关 -->
    <div class="invoice_center">
      <div>
        <label for="">开具发票</label>
        <el-radio-group v-model="invoiceNeedType">
          <el-radio :label="1">需要开发票</el-radio>
          <el-radio :label="0">不开发票</el-radio>
        </el-radio-group>
      </div>
      <div style="float: right;" v-if="invoiceNeedType == 1">
        <p v-show="selectInoiceData" class="invoice_title" @click="SelectInvoice">{{ selectInoiceData.header }}</p>
        <p v-show="selectInoiceData" class="alter" @click="SelectInvoice">变更</p>
        <p v-show="!selectInoiceData" class="invoice_title" @click="SelectInvoice">请选择发票信息</p>
      </div>

    </div>

    <template #footer>
      <div class="dialog-footer">
        <div class="close_button button" @click="ClosePaymentConfirm">取消</div>
        <div class="confirm_button button" @click="ConfirmPay">确定</div>
      </div>
    </template>
  </el-dialog>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  props: ['paymentConfirmVisible', 'advance_sale', 'selectInoiceData', 'ys_pay_type_list'],
  data () {
    // 这里存放数据
    return {
      invoiceNeedType: 1,
      isActive: -1,
      paymentData: ''
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    /**
     * @description: 选择发票
     * @return {*}
     */
    SelectInvoice () {
      this.$emit('SelectInvoice')
    },
    /**
     * @description: 选中支付方式
     * @param {*} item
     * @param {*} index
     * @return {*}
     */
    SelectPayment (item, index) {
      this.isActive = index
      this.paymentData = item
    },
    /**
     * @description: 关闭尾款支付弹窗
     * @return {*}
     */
    ClosePaymentConfirm () {
      this.$emit('ClosePaymentConfirm')
    },
    /**
     * @description: 确定支付
     * @return {*}
     */
    ConfirmPay () {
      if (!this.paymentData) {
        this.$message({
          message: '请选择支付方式',
          type: 'warning'
        })
        return false;
      }
      if (this.invoiceNeedType) {
        if (!this.selectInoiceData) {
          this.$message({
            message: '请选择发票信息',
            type: 'warning'
          })
          return false;
        } else {
          const invoiceParams = {
            is_invoice: 1,
            order_no: this.advance_sale.order_no,
            invoice_id: this.selectInoiceData.id
          }
          this.$api.save_invoice(invoiceParams).then(res => {
            console.log(res);
            if (res.code == 0) {
              const paymentParams = {
                pay_type: this.paymentData.pay_type,
                order_id: this.advance_sale.order_id,
              }
              this.$emit('BalancePayment', this.paymentData, paymentParams)
            }
          }).catch(e => {
            console.log(e);
          })
        }
      } else {
        console.log(this.paymentData);
        const params = {
          pay_type: this.paymentData.pay_type,
          order_id: this.advance_sale.order_id,
        }
        console.log(params);
        this.$emit('BalancePayment', this.paymentData, params)

        console.log('支付');
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang='scss' scoped>
// @import url(); 引入公共css类
.payment_confirm {
  .order_info {
    .goods_pic {
      width: 100px;
      vertical-align: middle;
    }

    .goods_info {
      display: inline-block;
      vertical-align: top;
      margin-left: 10px;
      width: 276px;

      .goods_name {
        font-size: 16px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        -webkit-line-clamp: 2;
        font-weight: 500;
        height: 46px;
      }

      .order_amount {
        font-weight: 400;
        font-size: 16px;
        color: #747474;
        margin-top: 24px;
        float: right;
      }
    }

    .earnest_money {
      font-size: 16px;
      color: #8B8B8B;
      margin-left: 30px;
      display: inline-block;
      vertical-align: top;
    }

    .money_wrap {
      float: right;
      display: inline-block;
      vertical-align: top;

      .label {
        width: 80px;
        text-align: right;
        display: inline-block;
      }

      .balance_money {
        .label {
          font-size: 16px;
          color: #EA8440;
        }

        font-size: 16px;
        color: #EA8440;
      }

      .freight {
        .label {
          font-size: 16px;
          color: #2A2A2A;
        }

        font-size: 16px;
        color: #2A2A2A;
        line-height: 60px;
      }

      .account {
        span {
          display: inline-block;
          vertical-align: middle;
        }

        .account_label {
          font-size: 16px;
          color: #2A2A2A;
        }

        .account_money {
          font-size: 24px;
          color: #E14200;
        }
      }
    }



    .payment_list {
      margin: 30px auto;
      width: 350px;

      li {

        text-align: center;
        background: #FFFFFF;
        border-radius: 6px;
        border: 1px solid #CECECE;
        width: 150px;
        display: inline-block;
        margin-bottom: 10px;
        position: relative;

        .active_tip {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 0;
          height: 0;
          /*边框颜色*/
          border-color: transparent #E14200 transparent transparent;
          /*边框样式*/
          border-style: solid;
          border-width: 24px 36px 0 0;
          i{
            position: absolute;
            top: -16px;
            left: 16px;
            font-size: 14px;
            color:#FFFFFF;
          }


        }

        img {
          width: 20px;
          vertical-align: middle;
        }

        span {
          font-size: 16px;
          line-height: 48px;
          display: inline-block;
          vertical-align: middle;
          margin-left: 8px;
        }

        cursor: pointer;

        &:nth-child(2) {
          margin: 0 20px;
        }
      }

      .active {
        border: 1px solid #df3031;
      }
    }
  }

  .invoice_center {
    margin-top: 20px;
    background: #F5F5F5;
    padding: 10px 20px;
    overflow: hidden;

    label {
      font-size: 14px;
      color: #222222;
      margin-right: 20px;
      vertical-align: middle;
      display: inline-block;
    }

    .el-radio-group {
      label {
        margin: 0 20px;
      }
    }

    .invoice_title {
      font-size: 14px;
      margin-top: 20px;
      display: inline-block;
      color: #E63A2C !important;
      border-bottom: 1px solid #E63A2C;
      cursor: pointer;
    }

    .alter {
      display: inline-block;
      font-size: 14px;
      margin-top: 20px;
      margin-left: 20px;
      color: #E63A2C !important;
      border-bottom: 1px solid #E63A2C;
      cursor: pointer;
    }

  }

  .dialog-footer {
    .button {
      width: 140px;
      display: inline-block;
      text-align: center;
      font-size: 18px;
      line-height: 40px;
      border-radius: 20px;
      margin: 0 10px;
      cursor: pointer;
      font-weight: 400;
      transition: all .3s;

      &:hover {
        opacity: .6;
      }
    }

    .close_button {
      border: 1px solid #dbdbdb;
    }

    .confirm_button {
      background: linear-gradient(86deg, #EA8541 0%, #EA6737 99%);
      color: #ffffff
    }
  }

}
</style>